export function createReducer(state, action, handlers) {
  const handler = handlers[action.type]
  if(handler){
    return handlers[action.type](state, action)
  } else {
    return state
  }
}

export function shouldFetchValue(state, valuePath, retryLimit = 1) {
  const value = state.getIn(valuePath)
  if(state.get('retryCount') > retryLimit) {
    return false
  } else if(state.get('isFetching')){
    return false
  } else if (state.get('isStale')){
    return true
  } else {
    return !value
  }
}
